import PublicLandsPopup from './PublicLandsPopup';

export default PublicLandsPopup;
